module.exports = __webpack_public_path__ + "static/media/printed.cbba9ba6.svg";